import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 2 — Compensation Management shell. Sidebar nav + <Outlet/>,
 * mirroring the recruiting/HR shell layout (reuses the `hr-shell` CSS classes).
 */

const NAV = [
  { to: '/compensation/cycles', label: 'Comp Cycles', testid: 'comp-nav-cycles' },
  { to: '/compensation/awards', label: 'Awards', testid: 'comp-nav-awards' },
  { to: '/compensation/grades', label: 'Grades & Bands', testid: 'comp-nav-grades' },
  { to: '/compensation/plans', label: 'Plans', testid: 'comp-nav-plans' },
  { to: '/compensation/statements', label: 'Total Rewards', testid: 'comp-nav-statements' },
];

export default function CompensationShell() {
  return (
    <div className="hr-shell" data-testid="comp-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Compensation</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink
                  to={n.to}
                  data-testid={n.testid}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
